/// <reference path="../../../tools/typings/angularjs/angular.d.ts"/>

module DealerwareWebComponents {
    "use strict";

    export class DownloadSelectDirectiveController {
        public static $inject: string[] = [];

        public id: string;
        public options: any;
        public onChange: any;
        public disabled: boolean;
        public selection: any;

        constructor() {
            this.setDownloadOptions();
        }

        private setDownloadOptions() : void {

            if (this.options && this.options.length) {
                return;
            }

            this.options = [{
                label: 'Download in view (CSV)',
                type: 'this',
                id: `${this.id}-item-in-view`,
            },{
                label: 'Download all (CSV)',
                type: 'all',
                id: `${this.id}-item-all`,
            }];
        }

        public onSelectionChange() : void {
            if (this.onChange && angular.isFunction(this.onChange)) {
                this.onChange({type: this.selection});
                this.selection = undefined;
            }
        }
    }

    getDealerwareWebComponentsModule().controller('DownloadSelectDirectiveController', DownloadSelectDirectiveController);

    export class DownloadSelectDirective implements ng.IDirective {
        public restrict         : string    =   'E';
        public controller       : any       =   'DownloadSelectDirectiveController';
        public controllerAs     : string    =   'ctrl';
        public bindToController : boolean   =   true;
        public replace          : boolean   =   false;
        public scope            : Object    =   {
            options: '=?',
            onChange: '&',
            id:       '@',
            disabled: '=?'
        };
        public transclude       : boolean   =   false;
        public templateUrl      : string    =   '/components/download_select/download_select.html';
        public static $inject   : string[]  =   [];

        constructor() {}

        public link : ng.IDirectiveLinkFn = (
            scope   :   ng.IScope,
            element :   ng.IAugmentedJQuery,
            attrs   :   ng.IAttributes,
            ctrls   :   any
        ) => {}
    }

    getDealerwareWebComponentsModule().directive("downloadSelect",() => new DownloadSelectDirective());
 }
